import styles from "./dotsCarrousel.module.css";

const DotsCarrousel = ({choices, carrousel}) => {
  return (
    <div className={styles.carrouselLowerCon}>
        {choices.map((choice, i) => (
          <div key={i} className={`${styles.dotLowerCon} ${carrousel === i ? styles.activeClassDot : ''}`}>
          </div>
        ))}
    </div>
  );
};
export default DotsCarrousel;

